/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuggestionTypeConsultationAliases {
  FIELD_SUGGESTION_TYPE_CONSULTATION = 'field-suggestion-type-consultation',
  FORM_SUGGESTION_TYPE_CONSULTATION = 'form-suggestion-type-consultation',
  LAYOUT_SUGGESTION_TYPE_CONSULTATION = 'layout-suggestion-type-consultation',
  PANEL_CONTENT_SUGGESTION_TYPE_CONSULTATION = 'panel-content-suggestion-type-consultation',
  RADIO_GROUP_TYPE_CONSULTATION = 'radio-group-type-consultation',
}
export { SuggestionTypeConsultationAliases };
